"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyAnalyticsData = makeEmptyAnalyticsData;
function makeEmptyAnalyticsData() {
    return {
        finalScore: 0,
        maxScore: 0,
        totalCardsUsed: 0,
        totalWildCardsUsed: 0,
        totalColumnsCleared: 0,
        totalColumnsBusted: 0,
        maxColumnScore: 0,
        maxClearStreak: 0,
    };
}
